import { render, staticRenderFns } from "./indexSubcontratos.vue?vue&type=template&id=1b79e101&"
import script from "./indexSubcontratos.vue?vue&type=script&lang=js&"
export * from "./indexSubcontratos.vue?vue&type=script&lang=js&"
import style0 from "./indexSubcontratos.vue?vue&type=style&index=0&id=1b79e101&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports